var map = {
	"./coprosma_lemon01.jpg": 8257,
	"./fern.jpg": 6291,
	"./flower.jpg": 1386,
	"./leaf.jpg": 8875,
	"./shrub.jpg": 2737,
	"./tree.jpg": 9365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6232;